module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Shipping Line Booking Order")])], 1), _vm._v(" "), (_vm.ALLMODULE > 0) ? _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.ALLMODULE ? _vm.ALLMODULE : '',
      "jobSeriesBanner": _vm.JOBSERIES ? _vm.JOBSERIES : '',
      "bannerClientName": _vm.mainEntryData.length > 0 ? _vm.mainEntryData[0].clientName : '',
      "trackingId": _vm.trackingId != '' ? _vm.trackingId : '',
      "iconId": "fa fa-ship"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booking Number *")]), _vm._v(" "), (_vm.BookingShippingLine.is_mainbookingFlow == 2) ? _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.viewPagePref == 1 ?
        true :
        _vm.mainEntryData[0].is_booking_updated == '1' ?
        false :
        _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.BookingShippingLine.ffBookingId ?
        true :
        false,
      "option-value": "booking_no",
      "option-text": "booking_no",
      "list": _vm.ConsoleBookingList,
      "placeholder": "Select Booking Number"
    },
    on: {
      "searchchange": _vm.SelectConsoleBooking
    },
    model: {
      value: (_vm.BookingShippingLine.bookingNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "bookingNumber", $$v)
      },
      expression: "BookingShippingLine.bookingNumber"
    }
  }) : _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "name": "bookingNumber",
      "id": "bookingNumber"
    },
    model: {
      value: (_vm.BookingShippingLine.bookingNumber),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "bookingNumber", $$v)
      },
      expression: "BookingShippingLine.bookingNumber"
    }
  })], 1), _vm._v(" "), (!_vm.BookingShippingLine.bookingNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBooking.bookingNumber))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Booking Documents")])], 1), _vm._v(" "), (_vm.uploadBookingStatus.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.uploadBookingStatus), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "disabled": _vm.viewPagePref == 1,
        "md-flex": "30"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Old Document - " + _vm._s(index + 1))])])
  })) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Booking Release Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "bookingDate",
      "name": "bookingDate"
    },
    model: {
      value: (_vm.BookingShippingLine.bookingDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "bookingDate", $$v)
      },
      expression: "BookingShippingLine.bookingDate"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.bookingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.bookingDate) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Booking Validity Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": (_vm.viewPagePref == 1 || _vm.BookingShippingLine.is_mainbookingFlow == 2) ? true : false,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "validityBookingDate",
      "name": "validityBookingDate"
    },
    model: {
      value: (_vm.BookingShippingLine.validityBookingDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "validityBookingDate", $$v)
      },
      expression: "BookingShippingLine.validityBookingDate"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.validityBookingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.validityBookingDate) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("SI Cutoff Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "SICutOff",
      "id": "SICutOff",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.SICutOff),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "SICutOff", $$v)
      },
      expression: "BookingShippingLine.SICutOff"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.SICutOff) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.SICutOff) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Gate/Forwarding Open Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "gateOpenDate",
      "id": "gateOpenDate",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.gateOpenDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "gateOpenDate", $$v)
      },
      expression: "BookingShippingLine.gateOpenDate"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.gateOpenDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.gateOpenDate) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Gate/Forwarding Close Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "gateCloseDate",
      "id": "gateCloseDate",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.gateCloseDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "gateCloseDate", $$v)
      },
      expression: "BookingShippingLine.gateCloseDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Port Cut Off Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "portCutDate",
      "id": "portCutDate",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.portCutDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "portCutDate", $$v)
      },
      expression: "BookingShippingLine.portCutDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("VGM CutOff Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "vgmCutOffDate",
      "id": "vgmCutOffDate",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.vgmCutOffDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "vgmCutOffDate", $$v)
      },
      expression: "BookingShippingLine.vgmCutOffDate"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.vgmCutOffDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.vgmCutOffDate) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("TR CutOff Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "documentCutOffDate",
      "id": "documentCutOffDate",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.documentCutOffDate),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "documentCutOffDate", $$v)
      },
      expression: "BookingShippingLine.documentCutOffDate"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.documentCutOffDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.documentCutOffDate) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Vessel Sail Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "VesselSailDate",
      "id": "VesselSailDate",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    on: {
      "input": function($event) {
        _vm.ChangeDate(
          _vm.BookingShippingLine.vessel_sale_start_date,
          _vm.BookingShippingLine.SICutOff
        )
      }
    },
    model: {
      value: (_vm.BookingShippingLine.vessel_sale_start_date),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "vessel_sale_start_date", $$v)
      },
      expression: "BookingShippingLine.vessel_sale_start_date"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.vessel_sale_start_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.vessel_sale_start_date) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Handover CutOff Date *")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "handover_cutoff_date",
      "id": "handover_cutoff_date",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.handover_cutoff_date),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "handover_cutoff_date", $$v)
      },
      expression: "BookingShippingLine.handover_cutoff_date"
    }
  }), _vm._v(" "), (!_vm.BookingShippingLine.handover_cutoff_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                " + _vm._s(_vm.errorBooking.handover_cutoff_date) + "\n              ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "name": "vesselName",
      "id": "vesselName"
    },
    model: {
      value: (_vm.BookingShippingLine.vesselName),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "vesselName", $$v)
      },
      expression: "BookingShippingLine.vesselName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Voyage No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "formatter": _vm.capitalizeAll,
      "name": "voyageNo",
      "id": "voyageNo"
    },
    model: {
      value: (_vm.BookingShippingLine.voyageNo),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "voyageNo", $$v)
      },
      expression: "BookingShippingLine.voyageNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Tentative Vessel ETA")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "vesselEta",
      "id": "vesselEta",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.vesselEta),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "vesselEta", $$v)
      },
      expression: "BookingShippingLine.vesselEta"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Tentative Vessel ETD")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.viewPagePref == 1,
      "lang": "en",
      "name": "vesselEtd",
      "id": "vesselEtd",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.BookingShippingLine.vesselEtd),
      callback: function($$v) {
        _vm.$set(_vm.BookingShippingLine, "vesselEtd", $$v)
      },
      expression: "BookingShippingLine.vesselEtd"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addBookingDetail
    }
  }, [_vm._v("Save & Proceed to Execution")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), (_vm.Created) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.Created) + " ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.Updated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.Updated) + " ")])]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-498d71a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/ffBooking.vue
// module id = 2595
// module chunks = 0